// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PiggyBankBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M25 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-5.5-7h-5a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 1 0 0-3ZM32 14v4a3.5 3.5 0 0 1-3.442 3.5l-1.908 5.341a2.5 2.5 0 0 1-2.355 1.659h-1.59a2.5 2.5 0 0 1-2.355-1.659l-.125-.341h-6.454l-.125.341a2.5 2.5 0 0 1-2.351 1.659h-1.59a2.5 2.5 0 0 1-2.355-1.659l-1.537-4.306a11.454 11.454 0 0 1-2.594-5.31A1.489 1.489 0 0 0 3 18a1.5 1.5 0 0 1-3 0 4.509 4.509 0 0 1 3.07-4.266A11.516 11.516 0 0 1 14.5 3.5h13a1.5 1.5 0 0 1 0 3h-1.25a11.5 11.5 0 0 1 2.81 3.931l.053.125A3.506 3.506 0 0 1 32 14Zm-3 0a.5.5 0 0 0-.5-.5h-.457a1.5 1.5 0 0 1-1.432-1.051A8.5 8.5 0 0 0 18.5 6.5h-4a8.5 8.5 0 0 0-6.268 14.242c.136.147.24.32.307.508l1.518 4.25h.886l.358-1a1.5 1.5 0 0 1 1.413-1h8.572a1.501 1.501 0 0 1 1.413 1l.358 1h.886l2.144-6a1.5 1.5 0 0 1 1.413-1h1a.5.5 0 0 0 .5-.5v-4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
